import { writable } from 'svelte/store';

/** A vertex of the active walk-area polygon. Coordinates ordered as
 * (lng, lat) for GeoJSON compatibility; lat/lng named explicitly to
 * avoid any [0]/[1] indexing ambiguity at callsites. */
export interface PolygonVertex {
  lng: number;
  lat: number;
}

/** The active polygon. null = no polygon; an array = closed polygon with
 * vertices in click order. Persists across map ↔ walk-list navigation
 * within a session; cleared on page reload. */
export const polygonStore = writable<PolygonVertex[] | null>(null);

/** Reset polygonStore to null. Used by the FAB clear action, the
 * on-map Clear button, and the cancel/ESC paths in the draw controller. */
export function clearPolygon(): void {
  polygonStore.set(null);
}
